import { biomarkerRangeInPercentage, getBiomarkerRangeColorOrder } from '../../utils/miscUtils';
import React from 'react';
import {
  IDiagnoseResult,
  IDigitalHealthProfile,
} from '../UI/SelectedSalesOrder/DigitalHealthProfileTab';
import styles from './BioMarkerRange.module.css';
import BiomarkerRangeSvg from './BioMarkerSvg';
import { useTranslation } from '../../hooks/useTranslations';

type Props = {
  product: IDigitalHealthProfile;
  biomarker: IDiagnoseResult;
};

const BiomarkerRanges: React.FC<Props> = ({ product, biomarker }) => {
  const { translations } = useTranslation();

  const biomarkerPosition: Record<number, number> = {
    1: 0.2,
    2: 20,
    3: 39.5,
    5: 60.5,
    6: 80,
  };

  const order = React.useMemo(() => {
    return getBiomarkerRangeColorOrder(biomarker, product);
  }, [product, biomarker]);

  const originalValue = React.useMemo(() => {
    return biomarkerRangeInPercentage(biomarker, product, order);
  }, [order, product, biomarker]);

  const value = React.useMemo(() => {
    return biomarkerPosition[order] + (originalValue * 19) / 100;
  }, [originalValue, order]);

  return (
    <div className={styles.container}>
      <div
        className={styles.bar}
        style={{
          background:
            biomarker.property_value === 'test_aborted'
              ? 'none'
              : 'linear-gradient(to right, #FF0300 0%, #FF0300 19%, #FFA800 20.25%, #FFA800 39.25%, #FFFFFF 39.25%, #FFFFFF 40.5%, #46D278 40.5%, #46D278 59.5%, #FFFFFF 59.5%, #FFFFFF 60.75%, #FFA800 60.75%, #FFA800 79.75%, #FF0300 81%, #FF0300 100%)',
        }}
      />
      <div
        className={styles.referenceRanges}
        style={{
          left: `${
            biomarker.property_id < 0
              ? biomarker?.reference_range_name === 'Positive'
                ? 20
                : 20
              : `${biomarkerPosition[order] + originalValue / 5}`
          }%`,
          transform: value > 10 ? 'translateX(-85px)' : 'none',
        }}
      >
        <div className={styles.valueContainer}>
          <div className={styles.value}>
            {!isNaN(parseFloat(biomarker?.property_value ?? '0')) &&
            (biomarker?.property_value?.length ?? 0) > 3
              ? Number(biomarker?.property_value).toFixed(2) + ' '
              : biomarker?.property_value}
          </div>
          <small className={styles.uomText}>{biomarker?.uom}</small>
          <span
            className={styles.range}
            style={{
              color: `#${biomarker.color_code}`,
            }}
          >
            {translations(`biomarkerDetails.${biomarker?.reference_range_name.toLowerCase()}`)}
          </span>
        </div>
      </div>
      <BiomarkerRangeSvg
        width={16}
        height={13}
        fill={`#4F4F4F`}
        className={styles.rangeSvg}
        style={{
          left: `${biomarkerPosition[order] + originalValue / 5}%`,
        }}
      />
    </div>
  );
};

export default BiomarkerRanges;
